import { createFilterOptions } from '@mui/material'
import { Filter } from 'components/core/search-filter/filter'
import { UserStatus } from 'pbts/c1/api/user/v1/user'
import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'

const UserStatusFilterOptions = [UserStatus.DELETED, UserStatus.DISABLED, UserStatus.ENABLED]
const StatusFilterOptions = createFilterOptions<UserStatus>({})

type UserStatusFilterProps = {
    value?: Array<UserStatus>
    onChange: (updated: { userStatuses: Array<UserStatus> }, shouldPropagate?: boolean) => void
}

export const UserStatusFilter = ({ value, onChange: _onChange }: UserStatusFilterProps): React.ReactElement => {
    const intl = useIntl()

    const renderLabel = useCallback(
        (option: UserStatus): string =>
            ({
                [UserStatus.DELETED]: intl.formatMessage({ id: 'deleted', defaultMessage: 'Deleted' }),
                [UserStatus.DISABLED]: intl.formatMessage({ id: 'disabled', defaultMessage: 'Suspended' }),
                [UserStatus.ENABLED]: intl.formatMessage({ id: 'enabled', defaultMessage: 'Active' }),
            }[option]),
        [intl],
    )

    const onChange = useCallback(
        (userStatuses: Array<UserStatus>): void => _onChange({ userStatuses }, true),
        [_onChange],
    )

    return (
        <Filter<UserStatus>
            label={intl.formatMessage({
                id: 'user_filter_status_type',
                defaultMessage: 'Status',
            })}
            options={UserStatusFilterOptions}
            selected={value}
            onChange={onChange}
            filterOptions={StatusFilterOptions}
            renderLabel={renderLabel}
        />
    )
}
